"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var MAX_TRANSLATIONS_PER_PAGE = 4;
var CardSourceListWrapper = function CardSourceListWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "page", _descriptor, _this);
      _this.onToggleSourceEditExpanded = function () {
        _state.OverlayUI.addOverlay('sourceEdit', {
          card: _this.props.card,
          word: _this.props.card.word
        });
      };
      _this.filterMeaningsForCard = function (meanings) {
        if (!_this.cardSynonymMeaningIds) {
          return meanings;
        }
        return meanings.filter(function (meaning) {
          return _this.cardSynonymMeaningIds.has(String(meaning.id));
        });
      };
      _this.incrementPage = function () {
        if (_this.maxPages > 1) {
          _this.page = _this.page < _this.maxPages ? _this.page + 1 : 1;
        }
      };
      _this.decrementPage = function () {
        if (_this.maxPages > 1) {
          _this.page = _this.page === 1 ? _this.maxPages : _this.page - 1;
        }
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.word && prevProps.word && this.props.word.id !== prevProps.word.id) {
          this.page = 1;
        }
      }
    }, {
      key: "translations",
      get: function get() {
        return this.props.word && this.props.word.vocabSourceForUser && this.props.word.vocabSourceForUser(_state.AppUI.user);
      }
    }, {
      key: "maxPages",
      get: function get() {
        return this.translations ? Math.ceil(this.translations.length / MAX_TRANSLATIONS_PER_PAGE) : 1;
      }
    }, {
      key: "paginatedTranslations",
      get: function get() {
        var startAt = (this.page - 1) * MAX_TRANSLATIONS_PER_PAGE;
        return this.translations ? (0, _lodash.slice)(this.translations, startAt, startAt + MAX_TRANSLATIONS_PER_PAGE) : [];
      }
    }, {
      key: "fontSize",
      get: function get() {
        var fontSizes = {
          1: 30,
          2: 26,
          3: 22,
          4: 20
        };
        return fontSizes[this.paginatedTranslations.length];
      }
    }, {
      key: "cardSynonymMeaningIds",
      get: function get() {
        var _this$props$card,
          _this$props$word,
          _this2 = this,
          _selectedAssociation$;
        if (!((_this$props$card = this.props.card) !== null && _this$props$card !== void 0 && _this$props$card.synonymAssociationId)) {
          return null;
        }
        var associations = ((_this$props$word = this.props.word) === null || _this$props$word === void 0 ? void 0 : _this$props$word.synonymAssociations) || [];
        var selectedAssociation = associations.find(function (item) {
          return item.id === _this2.props.card.synonymAssociationId;
        });
        if (!(selectedAssociation !== null && selectedAssociation !== void 0 && selectedAssociation.meaningId)) {
          return null;
        }
        var synonymId = (_selectedAssociation$ = selectedAssociation.synonym) === null || _selectedAssociation$ === void 0 ? void 0 : _selectedAssociation$.id;
        if (!synonymId) {
          return new Set([String(selectedAssociation.meaningId)]);
        }
        return new Set(associations.filter(function (item) {
          var _item$synonym;
          return ((_item$synonym = item.synonym) === null || _item$synonym === void 0 ? void 0 : _item$synonym.id) === synonymId && item.meaningId;
        }).map(function (item) {
          return String(item.meaningId);
        }));
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          page: this.page,
          onToggleSourceEditExpanded: this.onToggleSourceEditExpanded,
          translations: this.translations,
          maxPages: this.maxPages,
          paginatedTranslations: this.paginatedTranslations,
          fontSize: this.fontSize,
          cardSynonymMeaningIds: this.cardSynonymMeaningIds,
          filterMeaningsForCard: this.filterMeaningsForCard,
          incrementPage: this.incrementPage,
          decrementPage: this.decrementPage
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "page", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 1;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "translations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "translations"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "maxPages", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "maxPages"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "paginatedTranslations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "paginatedTranslations"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "fontSize", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "fontSize"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardSynonymMeaningIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardSynonymMeaningIds"), _class2.prototype), _class2)) || _class;
};
CardSourceListWrapper.displayName = 'CardSourceListWrapper';
var _default = exports["default"] = CardSourceListWrapper;